import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { Gateway } from 'src/features/gateway/utils/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/gateway/`;

interface DTO {
    parkingId: string;
    search: string;
}

const searchGateway = ({ parkingId, search }: DTO): Promise<ListResponseSmartParkAPI<Gateway>> =>
    axios.get(formatResourcePath(RESOURCE, { parkingId }), { params: { search } });

export { RESOURCE as SEARCH_GATEWAY_RESOURCE, searchGateway };
